import InitApi from "api/InitApi";
import { useQuery } from "react-query";
import useTokenStore from "store/tokenStore";

const STALE_TIME = 5 * 60 * 1000;

const fetchPaymentMethodAvailability = async (accessToken) => {
	const instance = await InitApi({ accessToken });
	const response = await instance.get("/payment-methods/availability");
	if (!response.data?.data?.methods) throw new Error("Payment method settings could not be loaded.");
    return response.data.data.methods;
};

const usePaymentMethodAvailability = () => {
	const { accessToken } = useTokenStore();

	return useQuery(["payment-method-availability"], () => fetchPaymentMethodAvailability(accessToken), {
		staleTime: STALE_TIME,
		cacheTime: STALE_TIME,
		refetchOnWindowFocus: false,
		retry: 1,
	});
};

export default usePaymentMethodAvailability;
